import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams } from 'ionic-angular';
import { AlertController } from 'ionic-angular';
import { HttpClient } from '@angular/common/http';
import { Storage } from '@ionic/storage';
import { AppConfigProvider } from '../../providers/app-config/app-config';

import { ShariahServiceProvider } from '../../providers/shariah-service/shariah-service';
/**
 * Generated class for the SettingPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-setting',
  templateUrl: 'setting.html'
})
export class SettingPage {
  user: any;
  user_id: number;
  token: string;
  name: string;
  phone: string;
  password: string;

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    private http: HttpClient,
    private appConfig: AppConfigProvider,
    private alertCtrl: AlertController,
    private storage: Storage,
    private shariahService: ShariahServiceProvider
  ) {}

  async ngOnInit() {
    this.user_id = await this.storage.get('user_id');
    this.token = await this.storage.get('token');

    this.shariahService.getUser(this.user_id, this.token).subscribe((data: any) => {
      console.log(data);
      this.user = data.result;
      this.name = this.user.name;
      this.phone = this.user.phone;
    });
  }

  updateUser() {
    this.alert('Are you sure?', 'You are about to update your user information.', () => {
      this.http
        .post(this.appConfig.apiUrl() + 'index.php/api/user/update', {
          user_id: this.user_id,
          name: this.name,
          phone: this.phone,
          app_key: this.appConfig.appKey()
        })
        .subscribe(
          (res: any) => {
            this.alertMessage('Success', 'Successfully updated user information.');
            this.navCtrl.pop();
          },
          err => {
            this.alertMessage('Error', 'Failed to update user information.');
          }
        );
    }, () => {
      console.log('NO');
    });
  }

  async showConfirm() {
    this.alert('Are you sure?', 'You are about to update your password.', () => {
      console.log('Agree clicked');

      this.http
        .post(this.appConfig.apiUrl() + 'index.php/api/login/update', {
          user_id: this.user_id,
          password: this.password,
          app_key: this.appConfig.appKey()
        })
        .subscribe(
          (res: any) => {
            this.alertMessage('Success', 'Successfully updated user password.');
          },
          err => {
            this.alertMessage('Error', 'Failed to update password');
          }
        );
    }, () => {
      console.log('NO');
    });

  }

  alert(title, message, yesHandler, noHandler) {
    const confirm = this.alertCtrl.create({
      title: title,
      message: message,
      buttons: [
        { text: 'No', handler: () => noHandler() },
        { text: 'Yes', handler: () => yesHandler() }
      ]
    });
    confirm.present();
  }

  alertMessage(title, subtitle) {
    let alert = this.alertCtrl.create({
      title: title,
      subTitle: subtitle,
      buttons: ['Dismiss']
    });
    alert.present();
  }
}



// WEBPACK FOOTER //
// ./src/pages/setting/setting.ts